const sessionKey = 'pageviews',
    showOnCount = 2;

function getPageViewCount(){
    const count = sessionStorage.getItem(sessionKey);

    return count !== null ? +count : 0;
}

function setPageViewCount(count){
    sessionStorage.setItem(sessionKey, count);
}

function isAnonymousCustomer(){
    return smartPak && smartPak.cdProfileCookie ? (!smartPak.cdProfileCookie.ExistingCustomer && !smartPak.cdProfileCookie.HasPassword) : false;
}

export default function spree(){
    if(!sessionStorage || !isAnonymousCustomer()){
        return;
    }

    let pageviews = getPageViewCount();

    setPageViewCount(pageviews + 1);

    if(pageviews === showOnCount){
        import('./spreeform').then(({default: spreeForm}) => spreeForm());
        return;
    }
}